module.exports = __webpack_public_path__ + "img/FirstBank.820fc343.png";